import { setupApolloClient as setupApolloClientCore } from '@ztechapps/webui.util'
import { routesDef } from './routes'

export const setupApolloClient = () => setupApolloClientCore(routesDef.LoginPage.altPath)
